module.exports = __webpack_public_path__ + "static/media/package_support_40.963e9fa8.svg";